import styled from '@mui/material/styles/styled';
import PropTypes from 'prop-types';

import Title from '../../elements/title/Title';

const TitleWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

const TitlePanel = ({ children, title, visible }) => {
  return (
    <TitleWrapper>
      <Title text={title} />
      {visible && children}
    </TitleWrapper>
  );
};

TitlePanel.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool,
};

export default TitlePanel;
